export default {
  name: "PeriodoField",
  props: {
    vModelFirst: {
      required: true,
    },
    vModelLast: {
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    title: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
    rulesLast: {
      default: () => [],
      type: Array,
    },
    rulesFirst: {
      default: () => [],
      type: Array,
    },
    loading: {
      type: Boolean,
    },
    disabledTwo: {
      default: false,
      type: Boolean,
    },
    disabledFirst: {
      default: false,
      type: Boolean,
    },
  
    responsive: {
      default: () => {
        return {
          cols: "12",
          sm: "12",
          md: "12",
          lg: "12",
        };
      },
      type: Object,
    },
  },

  mounted() {
    this.valueFirst = this.vModelFirst;
    this.valueLast = this.vModelLast;
  },

  methods: {
    emitBlurFirst() {
      this.$emit("on-blur-first");
    },
    emitBlurLast() {
      this.$emit("on-blur-last");
    }
  },

  watch: {
    valueFirst() {
      this.$emit("inputFirst", this.valueFirst);
    },

    valueLast() {
      this.$emit("inputLast", this.valueLast);
    },

    vModelFirst() {
      this.valueFirst = this.vModelFirst;
    },

    vModelLast() {
      this.valueLast = this.vModelLast;
    },
  },

  data: () => ({
    valueFirst: null,
    valueLast: null,
  }),
};
